'use client';

import { useIntl } from 'react-intl';
import StatusBadge from '@alltrails/denali/components/StatusBadge';
import useIsMobileSizedScreen from '@alltrails/denali/hooks/useIsMobileSizedScreen';
import NationalParkFilled from '@alltrails/denali/icons/NationalParkFilled';
import styles from './ManagedBadge.module.scss';

export default function ManagedBadge() {
  const intl = useIntl();
  const isMobile = useIsMobileSizedScreen();

  return !isMobile ? (
    <StatusBadge
      className={styles.badge}
      icon={{ Component: NationalParkFilled }}
      variant="inverse"
      text={intl.formatMessage({ defaultMessage: 'Managed' })}
      size="sm"
      treatment="default"
    />
  ) : (
    <NationalParkFilled className={styles.badge} size="xs" />
  );
}
